import {useCurrentPageType} from './PageTypeContext';
import {PageTypes} from './types';
import {useDeleteQueryParams} from './useDeleteQueryParams';
import {usePathname} from './useLocation';
import {useQueryParams} from './useQueryParams';

const pageTypesWherePageParamsAreDeprecated = [
  'category',
  'categoryLegacy',
  'brandShop',
  'brandLegacy',
] as PageTypes[];

export const usePageParamsRedirectUrls = () => {
  const pathname = usePathname();
  const pageType = useCurrentPageType();
  const queryParams = useQueryParams();
  const deleteQueryParams = useDeleteQueryParams();

  const containsDeprecatedPageParam =
    pageType &&
    pageTypesWherePageParamsAreDeprecated.includes(pageType) &&
    !!queryParams.get('page');

  if (containsDeprecatedPageParam) {
    const updatedUrlParams = deleteQueryParams('page');
    const updatedUrl = `${pathname}${
      updatedUrlParams.toString().length ? `?${updatedUrlParams}` : ''
    }`;

    return updatedUrl;
  }

  return undefined;
};
